// extracted by mini-css-extract-plugin
export default {"header":"fWXoy1kUJm4z0cJAbMk8","newDot":"LX_CxRL0K7A5Z_Nzj1r2"};